var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell-render-with-label"},[_vm._v(" "+_vm._s(_vm.params.value.value)+" "),_c('span',{staticStyle:{"font-size":"12px","color":"#95979a","font-weight":"400"}},[_vm._v(_vm._s(_vm.params.value.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }